export default __webpack_public_path__ + "static/media/smartswap-dark.20e3b5d6.png";